import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EActionTypes {
  SetMyHomeIdMigration = 'myHomeMigrationBanner/setMyHomeIdMigration',
}

export const setMyHomeIdMigration = actionGenerator<EActionTypes.SetMyHomeIdMigration, number>(
  EActionTypes.SetMyHomeIdMigration,
);

export type TMyHomeMigrationBannerActions = ReturnType<typeof setMyHomeIdMigration>;
